import { render, staticRenderFns } from "./Disable2fa.vue?vue&type=template&id=36fd2060&"
import script from "./Disable2fa.vue?vue&type=script&lang=js&"
export * from "./Disable2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports